<span app-link>
    <span (click)="navigate()">
        <ng-content></ng-content>
    </span>
    <sup (click)="openNewWindow()">
        <mat-icon svgIcon="link"></mat-icon>
    </sup>
</span>
